module.exports = __webpack_public_path__ + "3e46b23c9b38298a39134f782886dd08.svg";


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/4x3/vi.svg
// module id = ./node_modules/flag-icon-css/flags/4x3/vi.svg
// module chunks = 0